import React from 'react';

const MBTI_Arrow = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="98"
      height="4"
      viewBox="0 0 98 4"
      fill="none"
    >
      <path d="M2 2H96" stroke="#D9D9D9" strokeLinecap="round" />
      <rect width="4" height="4" rx="2" fill="#D9D9D9" />
      <rect x="94" width="4" height="4" rx="2" fill="#D9D9D9" />
    </svg>
  );
};

export default MBTI_Arrow;
